import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ArrayHelper } from 'apps/idl/src/helpers';
import { IUser, UserData } from 'apps/idl/src/model';
import { DestroyableComponentBase } from 'apps/idl/src/modules/utils/components/destroyable-component-base';
import { SecurityService, WorkspaceService } from 'apps/idl/src/services/security';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { ColorOption } from '../../../../../models/IColorOption';
import { PanneauService } from '../../../services/panneau.service';

@Component({
	selector: 'di-panneau-personalisation-workspace-contact',
	templateUrl: './panneau-prersonalisation-workspace.component.html',
	styleUrls: ['./panneau-prersonalisation-workspace.component.scss'],
})
export class PanneauPersonalisationWorkspaceComponent extends DestroyableComponentBase {

	@Input() onUpdate: () => void;
	

	constructor(
		private fb: FormBuilder,
		private svcPanneau : PanneauService,
		private svcWorkspace : WorkspaceService,
		private svcSecurity : SecurityService
	) { 
		super();
	}

	public colors = [
		{
			name: "Indigo",
			value: "Indigo",
		},
		{
			name: "Raspberry",
			value: "Raspberry",
		},
		{
			name: "OrangeClair",
			value: "OrangeClair",
		},
		{
			name: "Warning",
			value: "Warning",
		},
		{ name: "OK", value: "OK" },
		{ name: "BleuVif", value: "BleuVif" },
	];
	public selectedColor : ColorOption [];
	public wsForm: FormGroup;
	
	ngOnInit(): void {
		this.wsForm = this.fb.group({
			wsName: [UserData.current.workspaceInfos[0].name],
		});
		this.selectedColor = UserData.current.workspaceInfos[0].color ? [{name:UserData.current.workspaceInfos[0].color,value:UserData.current.workspaceInfos[0].color}] : [{name:"CouleurPrimaire",value:"CouleurPrimaire"}]
	}
	
	onGoBackClick()
	{
		this.svcPanneau.close()
	}

	onOptionClick = (colColorOptior: any[]) => {
		if(colColorOptior.length == 0) 
			this.selectedColor= [];
		else
			this.selectedColor = colColorOptior;
	}

	saveWSEdit()
	{
		const updatedWorkspaceId = UserData.current.workspaceInfos[0].id;
		const updatedWorkspaceName = this.wsForm.get("wsName").value;
		const updatedWorkspaceColor = this.selectedColor[0].value;
		UserData.current.workspaceInfos[0].color = updatedWorkspaceColor;
		UserData.current.workspaceInfos[0].name = updatedWorkspaceName;
		UserData.current.workspaceInfosList = UserData.current.workspaceInfosList.map((ws) => {
			if (ws.id === updatedWorkspaceId) {
				return {
					...ws,
					name: updatedWorkspaceName,
					color: updatedWorkspaceColor
				};
			}
			return ws;
		});
		this.svcWorkspace.saveWorkspaceANAKIN(this.wsForm.get("wsName").value,this.selectedColor[0].value).pipe(
			takeUntil(this.destroyed$),
			switchMap(() =>
				{
					const oldUser: IUser = JSON.parse(JSON.stringify(UserData.current));
					const newUser: IUser = JSON.parse(JSON.stringify(UserData.current));
					newUser.workspaceInfos = [...UserData.current.workspaceInfosList];
					return this.svcSecurity.saveUserDocument(newUser, oldUser);
				}),
				switchMap(() => {
					return this.svcSecurity.getLocalUserDocument(UserData.current);
				}),
				tap((user: IUser) => 
				{
					UserData.current = user;
					UserData.current.workspaceInfos = UserData.current.workspaceInfos.filter((ws) => ws.id == updatedWorkspaceId)
					if(this.onUpdate)
						this.onUpdate()
					this.svcPanneau.close();
				})
		).subscribe()
	}

	allValidForm() : boolean {
		return this.wsForm.invalid || !ArrayHelper.hasElements(this.selectedColor);
	}
}
